// Captura UTMs no primeiro carregamento da página e persiste em sessionStorage
// para não perder o rastreio durante a navegação entre etapas do formulário.

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

type UtmKey = (typeof UTM_KEYS)[number];
export type UtmData = Record<UtmKey, string>;

const STORAGE_KEY = "lead_utms_v1";

export function captureUtmsOnce(): void {
  if (typeof window === "undefined") return;
  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const utms: UtmData = {
      utm_source: params.get("utm_source") ?? "",
      utm_medium: params.get("utm_medium") ?? "",
      utm_campaign: params.get("utm_campaign") ?? "",
      utm_content: params.get("utm_content") ?? "",
      utm_term: params.get("utm_term") ?? "",
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
  } catch (err) {
    console.warn("[utm] Falha ao persistir UTMs:", err);
  }
}

export function getStoredUtms(): UtmData {
  const empty: UtmData = {
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_content: "",
    utm_term: "",
  };
  if (typeof window === "undefined") return empty;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return empty;
    const parsed = JSON.parse(raw) as Partial<UtmData>;
    return {
      utm_source: parsed.utm_source ?? "",
      utm_medium: parsed.utm_medium ?? "",
      utm_campaign: parsed.utm_campaign ?? "",
      utm_content: parsed.utm_content ?? "",
      utm_term: parsed.utm_term ?? "",
    };
  } catch {
    return empty;
  }
}
